<template>
	<div class="fc-pagination" v-if="totalPage != null && totalPage > 1">
		<a @click="changePage(currPage - 1)"
		   :disabled="currPage <= 1"></a>
		<a @click="changePage(item)"
		   v-if="totalPage <= 10"
			 v-for="(item, index) in totalPage" 
			 :class="{ 'fc-active': currPage == item }">
			{{ item }}
		</a>
		<a @click="changePage(item)"
		   v-if="totalPage > 10"
			 v-for="(item, index) in 5" 
			 :class="{ 'fc-active': currPage == item }">
			{{ item }}
		</a>
		<a disabled v-if="totalPage > 10 && currPage > 6">...</a>
		<a @click="changePage(currPage)"
		   v-if="totalPage > 10 && currPage > 5 && currPage < totalPage - 1"
			 class="fc-active">
			{{ currPage }}
		</a>
		<a disabled v-if="totalPage > 10 && currPage < totalPage - 2">...</a>
		<a @click="changePage(totalPage - 1)"
		   v-if="totalPage > 10" 
			 :class="{ 'fc-active': currPage == totalPage - 1 }">
			{{ totalPage - 1 }}
		</a>
		<a @click="changePage(totalPage)"
		   v-if="totalPage > 10" 
			 :class="{ 'fc-active': currPage == totalPage }">
			{{ totalPage }}
		</a>
		<a @click="changePage(currPage + 1)"
		   :disabled="currPage >= totalPage"></a>
	</div>
</template>
<script>
export default {
  name: 'Pagination',
  props: [
    'totalPage',
    'currPage',
    'param'
  ],
  methods: {
    clearPageParam: function () {
      if (process.browser) {
        var href = window.location.href
        if (href.indexOf(this.param) >= 0) {
          var value = ''
          var arrObj = href.split('?')
          if (arrObj.length > 1) {
            var arrPara = arrObj[1].split('&')
            var arr
            for (var i = 0; i < arrPara.length; i++) {
              arr = arrPara[i].split('=')
              if (arr !== null && arr[0] === this.param) {
                value = arr[1]
                break
              }
            }
          }
          if (value !== '') {
            href = href.replace('?' + this.param + '=' + value, '')
            href = href.replace('&' + this.param + '=' + value, '')
          }
        }
        return href
      }
    },
    changePage: function (page) {
      var href = this.clearPageParam()
      var param = 'page'
      if (this.param !== null && this.param !== undefined && this.param !== '') {
        param = this.param
      }
      if (href.indexOf('?') >= 0) {
        window.location.href = href + '&' + param + '=' + page
      } else {
        window.location.href = href + '?' + param + '=' + page
      }
    }
  }
}
</script>
<style scoped lang="less">
.fc-pagination {
	display: flex;
  flex-wrap: wrap;
	>a {
		font-size: 13px;
		color: #005542;
		height: 36px;
		width: 36px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #fff;
		margin:10px 3px;
		border-radius: 3px;
		border:1px solid #fff;
		cursor: pointer;
		&.fc-active{
			border-color:#009938;
		}
		&:first-of-type {
			margin-left: 0;
			&::before{
				content: "\f104";
				font-family: 'FontAwesome';
				color:#005542;
			}
			&[disabled]{
				pointer-events: none;
				&::before{
					color: #aaaaaa;
				}
			}
		}
		&:last-of-type {
			margin-right: 0;
			&::before{
				content: "\f105";
				font-family: 'FontAwesome';
				color:#005542;
			}
			&[disabled]{
				pointer-events: none;
				&::before{
					color: #aaaaaa;
				}
			}
		}
		&[disabled]{
			pointer-events: none;
			background-color: #ebebeb;
			border-color:#ebebeb;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Pagination/Pagination.vue